<template lang="html">
  <div
    :class="['control', klass]"
    @click="() => $emit('on-click')"
    @mouseover="mouseover"
    @mouseout="mouseout"
    :style="backgroundStyle"
  >
    <img
      :src="hover ? activeImageURL : imageURL"
      class="control-img"
    />
  </div>
</template>

<script>
import Hoverable from 'src/mixins/Hoverable.js'

export default {
  props: ['imageURL', 'activeImageURL', 'klass', "backgroundColor", "hoverbackgroundColor"],
  mixins: [Hoverable],
  data() {
    return {
      hover: false,
    }
  },
  computed: {
    backgroundStyle() {
      return `background-color: ${this.hover ? this.hoverBackground : this.background}`
    },
    background() {
      return this.backgroundColor ? this.backgroundColor : 'white'
    },
    hoverBackground() {
      return this.hoverbackgroundColor ? this.hoverbackgroundColor : '#5160EC'
    },
  }
}
</script>

<style lang="scss" scoped>
.control {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  z-index: 999;
  position: absolute;
  text-align: center;
  line-height: 28px;
  cursor: pointer;

  img.control-img {
    width: 16px;
    height: 16px;
  }
}
</style>
